<template>
    <div>
        <v-container fluid>
            <div v-if="loading">
                <v-layout wrap>
                    <v-flex 
                        xs12 
                        text-sm-right 
                        px-3 
                        py-3>
                        <v-skeleton-loader type="table" />
                    </v-flex>
                </v-layout>
            </div>
            <grid-validacion-solicitudes-administrador
                v-else-if="valido && !loading"
            />
            <v-alert 
                v-else 
                type="error">
                Usted no cuenta con el permiso para acceder a esta página.
            </v-alert>
            <v-snackbar
                key="snackbar_validacionsolocitudesadministrador"
                v-model="snackbarError"
                :bottom="true"
                :multi-line="true"
                color="error"
            >
                {{ textoError }}
                <v-btn 
                    dark 
                    text 
                    @click="snackbarError = false">
                    Cerrar
                </v-btn>
            </v-snackbar>
        </v-container>
    </div>
</template>
<script>
import { getAccesoAdministrador } from "@/api";

export default {
  name: "ValidacionSolicitudesAdministrador",
  components: {
    GridValidacionSolicitudesAdministrador: () =>
      import(
        "../../components/organisms/GridValidacionSolicitudesAdministrador"
      )
  },
  data () {
    return {
      settings: {
        maxScrollbarLength: 60
      },
      valido: false,
      loading: true,
      snackbarError: false,
      textoError: ""
    };
  },
  computed: {},
  beforeMount () {},
  mounted () {
    this.validarAcceso();
  },
  methods: {
    async validarAcceso () {
      var self = this;
      self.loading = true;
      self.valido = false;

      self.snackbarError = false;
      self.textoError = "";
      try {
        let response = await getAccesoAdministrador();

        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "True") {
              self.valido = true;
              self.loading = false;
            } else {
              self.loading = false;
              self.valido = false;
            }
          } else {
            self.loading = false;
            self.valido = false;

            self.snackbarError = true;
            self.textoError = response.data.message;
          }
        } else {
          self.loading = false;
          self.valido = false;

          self.snackbarError = true;
          self.textoError = "Error de red";
        }
      } catch (e) {
        self.loading = false;
        self.valido = false;

        self.snackbarError = true;
        self.textoError = e;
      }
    }
  }
};
</script>
